exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locations[data-v-275a5562]{position:relative;overflow:hidden;--dark:#262626;--light:#e6e6e6;--lighter:#f2f2f2;--transition:0.6s cubic-bezier(0.16,1,0.3,1)}.locations .overlay[data-v-275a5562]{content:\"\";position:absolute;top:0;left:0;height:100%;width:100%;background-color:var(--dark);opacity:0;pointer-events:none;transition:.2s ease-out}.locations .overlay.active[data-v-275a5562]{opacity:.5;pointer-events:all}", ""]);

// exports
